module.exports = __webpack_public_path__ + "static/media/FDYaZjJVQAUTg2W.24a0355e.webp";